(function(){
  // Velmont Cedar Shoe Tree — complimentary gift (product handle: cedar-shoe-tree)
  var GIFT_ID = 43360896286929;
  var GIFT_HANDLE = 'cedar-shoe-tree';
  // Old gift (shoe care brush set) — removed automatically if still in a cart
  var LEGACY_IDS = [43407692923089];
  var LEGACY_HANDLE = 'velmont-shoe-care-brush-set';
  var CAMPAIGN_END = new Date('2026-12-01T00:00:00-03:00').getTime();
  function campaignActive(){return Date.now()<CAMPAIGN_END;}
  var lock = false;
  var lastSig = '';

  function isGift(i){
    return i.variant_id===GIFT_ID || LEGACY_IDS.indexOf(i.variant_id)>-1 || i.handle===GIFT_HANDLE || i.handle===LEGACY_HANDLE || (i.properties && i.properties._gift);
  }

  function pairs(cart){var q=0;cart.items.forEach(function(i){if(!isGift(i))q+=i.quantity;});return q;}
  function money(c){var cur=(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD';return new Intl.NumberFormat('en-US',{style:'currency',currency:cur}).format(c/100);}

  function paint(cart){
    var qty=pairs(cart);
    var box=document.getElementById('ssco');
    if(box){
      box.style.display=campaignActive()?"":"none";
      var fill=document.getElementById('sscoFill');
      var msg=document.getElementById('sscoMsg');
      var pct=qty>=4?100:qty>=3?66:qty>=2?33:(qty>=1?16:0);
      if(fill)fill.style.width=pct+'%';
      box.querySelectorAll('.ssco-step').forEach(function(st){
        st.classList.toggle('on',qty>=parseInt(st.getAttribute('data-step'),10));
      });
      if(msg){
        if(qty>=4)msg.innerHTML='Maximum unlocked: <b>+30% off your order</b>';
        else if(qty===3)msg.innerHTML='<b>+25% off</b> unlocked. Add 1 more for <b>+30% off</b>';
        else if(qty===2)msg.innerHTML='<b>+20% off</b> unlocked. Add 1 more for <b>+25% off</b>';
        else if(qty===1)msg.innerHTML='Add 1 more pair and unlock <b>+20% off your order</b>';
        else msg.innerHTML='Add 2 pairs and unlock <b>+20% off your order</b>';
      }
    }
    var sav=document.getElementById('sscoSav');
    if(sav){
      var d=cart.total_discount||0;
      var v=sav.querySelector('.ssco-sav-val');
      if(d>0){v.textContent='-'+money(d);sav.style.display='flex';}else{sav.style.display='none';}
    }
  }

  function reloadDrawer(){
    fetch(window.location.pathname+'?sections=cart-drawer-section',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(data){
        var html=data['cart-drawer-section'];
        if(!html){ read(); return; }
        var doc=new DOMParser().parseFromString(html,'text/html');
        var novo=doc.querySelector('cart-drawer-component');
        var atual=document.querySelector('cart-drawer-component');
        if(novo&&atual&&novo.innerHTML!==atual.innerHTML){
          atual.style.transition='none';
          atual.innerHTML=novo.innerHTML;
        }
        setTimeout(read,120);
      })
      .catch(function(){ setTimeout(read,250); });
  }

  function syncGift(cart){
    if(lock) return;
    var qty=pairs(cart);
    var gifts=cart.items.filter(function(i){return i.variant_id===GIFT_ID;});
    var g=gifts[0];
    var stale=cart.items.filter(function(i){return isGift(i) && i.variant_id!==GIFT_ID;});
    var url,body;

    if(stale.length || gifts.length>1){ url='/cart/update.js'; body={updates:{}}; stale.forEach(function(i){body.updates[i.key]=0;}); gifts.slice(1).forEach(function(i){body.updates[i.key]=0;}); }
    else if(campaignActive() && qty>=1 && !g){ url='/cart/add.js'; body={id:GIFT_ID,quantity:1,properties:{_gift:'cedar-shoe-tree'}}; }
    else if((!campaignActive() || qty<1) && g){ url='/cart/change.js'; body={id:g.key,quantity:0}; }
    else if(g && g.quantity!==1){ url='/cart/change.js'; body={id:g.key,quantity:1}; }
    else { return; }

    lock=true;
    fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(){ setTimeout(function(){ lock=false; reloadDrawer(); },180); })
      .catch(function(){ lock=false; });
  }

  function read(){
    fetch('/cart.js',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(cart){
        var sig=campaignActive()+'|'+cart.item_count+'|'+cart.items.map(function(i){return i.key+':'+i.quantity;}).join(',');
        paint(cart);
        if(sig!==lastSig){ lastSig=sig; syncGift(cart); }
      })
      .catch(function(){});
  }

  function timer(){
    if(window.__ssT) return;
    var el=document.getElementById('sscoTimer'); if(!el) return;
    window.__ssT=setInterval(function(){
      var t=document.getElementById('sscoTimer');
      if(!t){clearInterval(window.__ssT);window.__ssT=null;return;}
      var d=Math.max(0,CAMPAIGN_END-Date.now());
      if(d===0){t.textContent='The sale has ended';clearInterval(window.__ssT);return;}
      var days=Math.floor(d/86400000),h=Math.floor(d%86400000/3600000),m=Math.floor(d%3600000/60000),s=Math.floor(d%60000/1000);
      t.textContent=days+'d '+h+'h '+m+'m '+s+'s';
    },1000);
  }

  function loop(){ timer(); read(); }

  ['cart:change','cart:updated','cart:update','cart:refresh','variant:add','cart:build'].forEach(function(e){
    document.addEventListener(e,function(){ setTimeout(read,400); });
    document.documentElement.addEventListener(e,function(){ setTimeout(read,400); });
  });

  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('button, [type="submit"], cart-drawer-component')){
      setTimeout(read,600);
      setTimeout(read,1200);
    }
  },true);

  document.addEventListener('DOMContentLoaded',loop);
  setInterval(loop,1500);
  loop();
})();
